import { render, staticRenderFns } from "./FeatureInfosPanel.vue?vue&type=template&id=296153ff&scoped=true"
import script from "./FeatureInfosPanel.vue?vue&type=script&lang=ts"
export * from "./FeatureInfosPanel.vue?vue&type=script&lang=ts"
import style0 from "./FeatureInfosPanel.vue?vue&type=style&index=0&id=296153ff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296153ff",
  null
  
)

export default component.exports